import { ButtonSecondaryDiv } from "@components/Buttons";
import { SIGNATURE_BASE_URL } from "@constants/constants";
import axios from "axios";
import Link from "next/link";
import React, { useState } from "react";
import { FiExternalLink } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { handleVerify } from "@utils/signature_owner";

const SignatureLogin2FA = ({ userData, show, setShow }) => {
  const email = userData?.result?.user?.email;
  const [OTP, setOTP] = useState("");
  const [messages, setMessages] = useState({ general: "", generalError: "" });
  const closePopup = () => {
    setOTP("");
    setShow(false);
    setMessages({ general: "", generalError: "" });
  };

  const verifyCB = ({ success }) => {
    if (success) {
      closePopup();
    } else {
    }
  };

  if (!show) return null;
  return (
    <div
      onClick={() => {}}
      className="fixed z-[1000] top-0 left-0 w-[100svw] h-[100svh] bg-black/20 flex justify-center items-center text-left"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="min-h-[450px] p-6 rounded-lg bg-white flex items-start justify-between flex-col w-[500px] w-max-[95%] m-2 relative"
      >
        <MdClose
          className="absolute top-6 right-6 cursor-pointer text-3xl"
          onClick={closePopup}
        />
        <div>
          <h2 className="mb-4 text-2xl text-center w-full">
            Two Factor Authentication
          </h2>
          <p className="text-gray-700 text-sm text-center">
            To access two-factor authentication please use an TOTP app for
            example Google Authenticator
          </p>
        </div>
        <div className="w-full flex flex-col items-center justify-center gap-2 my-6">
          <input
            autoFocus
            type="text"
            placeholder="Enter OTP"
            className="w-full p-2.5 rounded-md border-gray-700 border-2 focus:outline-none mb-2"
            value={OTP}
            onChange={(e) => setOTP(e.target.value)}
          />
          <ButtonSecondaryDiv
            buttonText="Verify"
            onclick={async () => {
              let data = await handleVerify({
                email,
                OTP,
                userData,
                cb: verifyCB,
              });
              if (!data?.success) {
                setMessages({ generalError: data?.error });
              }
            }}
          />
          <div className="mt-4 text-xs text-center w-full text-red-500 h-4">
            {messages?.generalError || ""}
          </div>
        </div>
        <Link
          href={`mailto:${email}`}
          className="w-full text-gray-700 text-sm underline flex gap-2 items-center mt-6 justify-center"
        >
          In case you do not have access to you device contact us
          <FiExternalLink />
        </Link>
      </div>
    </div>
  );
};

export default SignatureLogin2FA;
